import { functionDoc } from '../functionDoc';
import { ROLES, SHOTS } from '../docHelpers';

/** Documentación detallada (plantilla 12 apartados) de cada función del menú Compras. */
export const comprasSections = [
  functionDoc({
    
      "id": "compras-proveedores-list",
      "name": "Proveedores — listado",
      "type": "list",
      "route": "/suppliers",
      "locationPath": "Compras > Proveedores",
      "generalDescription": "Consulta del maestro de proveedores usado en órdenes de compra, órdenes de servicio y documentos de compra. Permite buscar por RUC o razón social y acceder al alta o edición. Los datos fiscales correctos evitan inconsistencias al registrar facturas del proveedor.",
      "prerequisites": [
        "Acceso al módulo Compras (administrador o usuario limitado con Compras habilitado).",
        "Si la empresa usa sedes de compra, seleccione la sede activa en la barra superior antes de operar documentos."
      ],
      "interfaceElements": [
        {
          "name": "Búsqueda por documento o nombre",
          "controlType": "Texto",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Filtra la tabla de proveedores.",
          "behavior": "Búsqueda parcial sobre razón social y número de documento."
        },
        {
          "name": "Tabla de proveedores",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "description": "Muestra RUC/DNI, razón social, contacto y estado.",
          "behavior": ""
        },
        {
          "name": "Nuevo proveedor",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre registro vacío.",
          "behavior": ""
        },
        {
          "name": "Editar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el proveedor seleccionado.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Compras → Proveedores.",
        "Busque el proveedor si la lista es larga.",
        "Edite o cree según necesidad."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "compras-proveedores-create",
        "compras-proveedores-edit",
        "compras-documentos-form"
      ],
      "observations": [
        "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil.",
        "Los totales del listado pueden mostrarse en PEN o USD según columnas y dual currency."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-proveedores-create",
      "name": "Proveedores — nuevo",
      "type": "form",
      "route": "/suppliers/create",
      "locationPath": "Compras > Proveedores > Nuevo",
      "generalDescription": "Alta de proveedor con identificación tributaria, razón social, dirección y datos de contacto. El proveedor queda disponible en selectores de OC, OS y documentos.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Tipo y número de documento",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "RUC para empresas; validación de longitud según tipo.",
          "behavior": ""
        },
        {
          "name": "Razón social",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Nombre que figurará en documentos y reportes.",
          "behavior": ""
        },
        {
          "name": "Dirección y contacto",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Opcional pero recomendable para logística y pagos.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-proveedores-list",
        "compras-oc-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-proveedores-edit",
      "name": "Proveedores — edición",
      "type": "form",
      "route": "/suppliers/:id/edit",
      "locationPath": "Compras > Proveedores > Editar",
      "generalDescription": "Actualización de datos del proveedor existente. Cambios en RUC o razón social deben alinearse con las facturas que registrará; documentos ya emitidos conservan el dato histórico grabado al momento del registro.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Identificación fiscal",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Evite duplicar otro proveedor con el mismo documento.",
          "behavior": ""
        },
        {
          "name": "Razón social y contacto",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Texto",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-proveedores-list",
        "compras-documentos-edit"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-requerimientos-list",
      "name": "Requerimientos — listado",
      "type": "list",
      "route": "/requirements",
      "locationPath": "Compras > Requerimientos",
      "generalDescription": "Listado de solicitudes internas de compra antes de emitir OC u OS. Muestra estado (borrador, enviado, atendido según implementación), solicitante y fechas. Sirve para trazabilidad solicitud → orden.",
      "prerequisites": [
        "Acceso al módulo Compras (administrador o usuario limitado con Compras habilitado).",
        "Si la empresa usa sedes de compra, seleccione la sede activa en la barra superior antes de operar documentos."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Por fecha, estado, área o texto en número de requerimiento.",
          "behavior": ""
        },
        {
          "name": "Número, fecha, solicitante, estado y totales estimados si aplica.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo requerimiento",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Formulario de alta.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Menú lateral Compras → Requerimientos.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "compras-requerimientos-create",
        "compras-requerimientos-edit",
        "compras-oc-form"
      ],
      "observations": [
        "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil.",
        "Los totales del listado pueden mostrarse en PEN o USD según columnas y dual currency."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-requerimientos-create",
      "name": "Requerimientos — nuevo",
      "type": "form",
      "route": "/requirements/create",
      "locationPath": "Compras > Requerimientos > Nuevo",
      "generalDescription": "Documento interno: no compromete stock ni obligación con proveedor hasta convertirse en orden. Cabecera con solicitante, almacén o área destino, fecha requerida y grilla de productos con cantidades.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Solicitante / área",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Quién requiere y dónde se consumirá.",
          "behavior": ""
        },
        {
          "name": "Fecha requerida",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Fecha",
          "behavior": ""
        },
        {
          "name": "Grilla de ítems",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Producto, cantidad, unidad y observación por línea.",
          "behavior": ""
        },
        {
          "name": "Observaciones",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Instrucciones para el comprador.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Almacén central pide insumos de limpieza.",
        "data": {
          "Área": "Almacén Lima",
          "Ítems": "3 productos"
        },
        "steps": [
          "Nuevo requerimiento",
          "Agregar líneas",
          "Guardar y opcionalmente imprimir para firma"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-requerimientos-list",
        "compras-oc-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-requerimientos-edit",
      "name": "Requerimientos — edición",
      "type": "form",
      "route": "/requirements/:id/edit",
      "locationPath": "Compras > Requerimientos > Editar",
      "generalDescription": "Modificación de un requerimiento existente mientras el flujo lo permita (por ejemplo en borrador). Permite ajustar cantidades o agregar líneas antes de vincular a una OC.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Cabecera",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Pueden bloquearse según estado.",
          "behavior": ""
        },
        {
          "name": "Ítems",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Grilla",
          "behavior": ""
        },
        {
          "name": "Imprimir",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre vista imprimible del requerimiento.",
          "behavior": "Ruta /requirements/:id/print"
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-requerimientos-list",
        "compras-requerimientos-print"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-requerimientos-print",
      "name": "Requerimientos — imprimir",
      "type": "screen",
      "route": "/requirements/:id/print",
      "locationPath": "Compras > Requerimientos > Imprimir",
      "generalDescription": "Vista imprimible del requerimiento para firma de jefatura o archivo físico. No modifica datos; use el navegador o botón Imprimir del sistema.",
      "prerequisites": [
        "Requerimiento guardado previamente."
      ],
      "interfaceElements": [
        {
          "name": "Imprimir / PDF",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Dispara impresión del navegador.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-requerimientos-edit"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-oc-list",
      "name": "Órdenes de compra — listado",
      "type": "list",
      "route": "/purchase-orders",
      "locationPath": "Compras > Órdenes de compra",
      "generalDescription": "Consulta de órdenes de compra emitidas y en borrador. Muestra proveedor, moneda, totales y estado. Desde aquí se edita, imprime o da seguimiento hasta la factura.",
      "prerequisites": [
        "Acceso al módulo Compras (administrador o usuario limitado con Compras habilitado).",
        "Si la empresa usa sedes de compra, seleccione la sede activa en la barra superior antes de operar documentos."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Proveedor, fechas, estado, número de OC, sede de compra si aplica.",
          "behavior": ""
        },
        {
          "name": "Número OC, proveedor, fecha, moneda, total, estado.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nueva OC",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Formulario de orden de compra.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Menú lateral Compras → Órdenes de compra.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "compras-oc-form",
        "compras-oc-edit",
        "compras-documentos-form"
      ],
      "observations": [
        "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil.",
        "Los totales del listado pueden mostrarse en PEN o USD según columnas y dual currency."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-oc-form",
      "name": "Órdenes de compra — nueva",
      "type": "form",
      "route": "/purchase-orders/create",
      "locationPath": "Compras > Órdenes de compra > Nueva",
      "generalDescription": "Compromiso formal con proveedor: precios, cantidades, IGV, condición de pago y opcional vinculación a requerimientos. Al emitir recibe numeración y puede imprimirse en PDF para el proveedor.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Proveedor",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Maestro de proveedores.",
          "behavior": ""
        },
        {
          "name": "Moneda y tipo de cambio",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "PEN o USD; TC para totales en soles si dual currency.",
          "behavior": ""
        },
        {
          "name": "Sede de compra",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Visible si comprasPurchaseSitesEnabled.",
          "behavior": "Filtra series y reportes por sede."
        },
        {
          "name": "Condición de pago",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Select",
          "behavior": ""
        },
        {
          "name": "Grilla productos",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Cantidad, precio unitario, descuento, IGV, proyecto si aplica.",
          "behavior": ""
        },
        {
          "name": "Vincular requerimiento",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Trae líneas aprobadas del requerimiento.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Compra de cemento contra requerimiento aprobado.",
        "data": {
          "Proveedor": "Distribuidora XYZ",
          "Moneda": "PEN"
        },
        "steps": [
          "Nueva OC",
          "Vincular requerimiento",
          "Emitir e imprimir PDF"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-oc-list",
        "compras-requerimientos-list",
        "compras-documentos-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-oc-edit",
      "name": "Órdenes de compra — edición",
      "type": "form",
      "route": "/purchase-orders/:id/edit",
      "locationPath": "Compras > Órdenes de compra > Editar",
      "generalDescription": "Edición de OC en estados permitidos. Ajuste líneas, precios o condiciones antes de recepción total. Documentos facturados pueden restringir cambios según reglas del sistema.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Estado de la OC",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": true,
          "description": "Borrador, emitida, cerrada, etc.",
          "behavior": ""
        },
        {
          "name": "Ítems y totales",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Grilla",
          "behavior": ""
        },
        {
          "name": "Imprimir OC",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "PDF de orden para proveedor.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-oc-list",
        "compras-oc-print"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-oc-print",
      "name": "Órdenes de compra — imprimir",
      "type": "screen",
      "route": "/purchase-orders/:id/print",
      "locationPath": "Compras > Órdenes de compra > Imprimir",
      "generalDescription": "PDF o vista de impresión de la orden de compra con logo, proveedor, líneas y totales. Envíela al proveedor por correo tras emitir.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Descargar / Imprimir",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Genera PDF con jsPDF según plantilla del sistema.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-oc-edit"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-os-list",
      "name": "Órdenes de servicio (compra) — listado",
      "type": "list",
      "route": "/service-orders",
      "locationPath": "Compras > Órdenes de servicio",
      "generalDescription": "Listado de órdenes de servicio de compra para contratación de servicios no inventariables como en una OC de productos.",
      "prerequisites": [
        "Acceso al módulo Compras (administrador o usuario limitado con Compras habilitado).",
        "Si la empresa usa sedes de compra, seleccione la sede activa en la barra superior antes de operar documentos."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Órdenes de servicio.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "compras-os-form",
        "compras-os-edit"
      ],
      "observations": [
        "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil.",
        "Los totales del listado pueden mostrarse en PEN o USD según columnas y dual currency."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-os-form",
      "name": "Órdenes de servicio (compra) — nueva",
      "type": "form",
      "route": "/service-orders/create",
      "locationPath": "Compras > Órdenes de servicio > Nueva",
      "generalDescription": "Contratación de servicios a proveedores: cabecera con proveedor, moneda, fechas de servicio y líneas con servicio del catálogo, cantidad y precio.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Proveedor",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Select",
          "behavior": ""
        },
        {
          "name": "Servicio",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Servicios dados de alta en Gestión.",
          "behavior": ""
        },
        {
          "name": "Cantidad y precio",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Numéricos",
          "behavior": ""
        },
        {
          "name": "Fechas de servicio",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Para prorrateo en reportes.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-os-list",
        "compras-documentos-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-os-edit",
      "name": "Órdenes de servicio (compra) — edición",
      "type": "form",
      "route": "/service-orders/:id/edit",
      "locationPath": "Compras > Órdenes de servicio > Editar",
      "generalDescription": "Modifica OS de compra antes de facturación completa. Controle saldos pendientes al vincular documentos.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Líneas de servicio",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Grilla",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-os-list",
        "compras-os-print"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-os-print",
      "name": "Órdenes de servicio (compra) — imprimir",
      "type": "screen",
      "route": "/service-orders/:id/print",
      "locationPath": "Compras > Órdenes de servicio > Imprimir",
      "generalDescription": "Impresión de la OS de compra para envío al proveedor de servicios.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Imprimir",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-os-edit"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-continuos-list",
      "name": "Servicios continuos (compras) — listado",
      "type": "list",
      "route": "/continuous-services",
      "locationPath": "Compras > Servicios continuos",
      "generalDescription": "Contratos o suministros recurrentes (alquileres, servicios mensuales). Lista proveedor, periodicidad y montos base; el detalle permite registrar cada factura hija.",
      "prerequisites": [
        "Acceso al módulo Compras (administrador o usuario limitado con Compras habilitado).",
        "Si la empresa usa sedes de compra, seleccione la sede activa en la barra superior antes de operar documentos."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Acota resultados por fechas, estado, proveedor o texto libre según la pantalla.",
          "behavior": ""
        },
        {
          "name": "Muestra filas con datos clave; clic o botón Editar abre el detalle.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo / Crear",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre el formulario de alta.",
          "behavior": "Usuarios en solo lectura no lo ven."
        }
      ],
      "procedure": [
        "Menú lateral Compras → Servicios continuos.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "compras-continuos-form",
        "compras-continuos-detail"
      ],
      "observations": [
        "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil.",
        "Los totales del listado pueden mostrarse en PEN o USD según columnas y dual currency."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-continuos-form",
      "name": "Servicios continuos (compras) — nuevo",
      "type": "form",
      "route": "/continuous-services/create",
      "locationPath": "Compras > Servicios continuos > Nuevo",
      "generalDescription": "Define proveedor, servicio o concepto, monto o cantidad recurrente y periodicidad. Cada período se registra un documento hijo desde el detalle.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Proveedor",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Select",
          "behavior": ""
        },
        {
          "name": "Periodicidad",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Mensual, quincenal, etc.",
          "behavior": ""
        },
        {
          "name": "Monto o cantidad base",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Numérico",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-continuos-detail",
        "compras-documentos-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-continuos-detail",
      "name": "Servicios continuos (compras) — detalle",
      "type": "screen",
      "route": "/continuous-services/:id",
      "locationPath": "Compras > Servicios continuos > Detalle",
      "generalDescription": "Vista de contrato recurrente: historial de documentos generados, botón para registrar nueva factura del período y datos de control del servicio.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Documentos hijos por período con montos y estados.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Registrar documento del período",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Atajo hacia documento de compra vinculado.",
          "behavior": ""
        },
        {
          "name": "Imprimir resumen",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Si está disponible en pantalla.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-continuos-form",
        "compras-documentos-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-continuos-print",
      "name": "Servicios continuos (compras) — imprimir",
      "type": "screen",
      "route": "/continuous-services/:id/print",
      "locationPath": "Compras > Servicios continuos > Imprimir",
      "generalDescription": "Impresión del resumen del servicio continuo para archivo o firma interna.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Imprimir",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-continuos-detail"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-documentos-list",
      "name": "Documentos de compra — listado",
      "type": "list",
      "route": "/documents",
      "locationPath": "Compras > Documentos",
      "generalDescription": "Facturas, boletas y notas del proveedor registradas en el sistema. Actualizan cuentas por pagar y pueden generar guía de ingreso al confirmar.",
      "prerequisites": [
        "Acceso al módulo Compras (administrador o usuario limitado con Compras habilitado).",
        "Si la empresa usa sedes de compra, seleccione la sede activa en la barra superior antes de operar documentos."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Proveedor, tipo SUNAT, serie-número, rango de fechas, estado.",
          "behavior": ""
        },
        {
          "name": "Tipo, serie-número, proveedor, fecha, total, moneda.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Nuevo documento",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "",
          "behavior": ""
        }
      ],
      "procedure": [
        "Menú lateral Compras → Documentos.",
        "Ajuste filtros si necesita acotar la búsqueda.",
        "Revise la tabla; use Editar o la fila para modificar un registro existente.",
        "Pulse Nuevo para registrar uno nuevo."
      ],
      "practicalExample": {
        "context": "El área de compras revisa pendientes del mes.",
        "data": {
          "Acción": "Filtrar y abrir un documento",
          "Período": "Mes en curso"
        },
        "steps": [
          "Entre al listado",
          "Filtre por fecha",
          "Abra el registro a revisar"
        ]
      },
      "validations": [
        "Un listado vacío puede ser normal si no hay registros en el filtro aplicado."
      ],
      "expectedResult": [
        "Tabla actualizada con los registros que cumplen el filtro.",
        "Navegación al formulario de creación o edición."
      ],
      "commonErrors": [
        {
          "error": "No veo registros",
          "cause": "Filtros muy restrictivos o sede de compra distinta.",
          "solution": "Limpie filtros y confirme la sede seleccionada."
        },
        {
          "error": "No puedo crear",
          "cause": "Usuario limitado en solo lectura.",
          "solution": "Solicite permiso de escritura al administrador."
        }
      ],
      "relatedFunctions": [
        "compras-documentos-form",
        "compras-documentos-edit"
      ],
      "observations": [
        "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil.",
        "Los totales del listado pueden mostrarse en PEN o USD según columnas y dual currency."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-documentos-form",
      "name": "Documentos de compra — nuevo",
      "type": "form",
      "route": "/documents/create",
      "locationPath": "Compras > Documentos > Nuevo",
      "generalDescription": "Replica el comprobante del proveedor: tipo SUNAT, serie-número, fecha, moneda, líneas con producto o servicio. Puede importar saldo de OC/OS.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Tipo y serie-número",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Select + texto",
          "behavior": ""
        },
        {
          "name": "Proveedor",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Select",
          "behavior": ""
        },
        {
          "name": "Líneas",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Cantidad, precio, IGV; botón traer de OC/OS.",
          "behavior": ""
        },
        {
          "name": "Totales",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": true,
          "description": "Base, IGV y total deben cuadrar con líneas.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-documentos-list",
        "compras-oc-list"
      ],
      "observations": [
        "Documentos de integración ERP pueden ser solo lectura en pantalla."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-documentos-edit",
      "name": "Documentos de compra — edición",
      "type": "form",
      "route": "/documents/:id/edit",
      "locationPath": "Compras > Documentos > Editar",
      "generalDescription": "Corrige o completa un documento en estado editable. Confirmado puede bloquear campos; anulaciones siguen política de su empresa.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Referencia OC/OS",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Trazabilidad precio y cantidad pactada.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-documentos-list",
        "compras-documentos-print"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-documentos-print",
      "name": "Documentos de compra — imprimir",
      "type": "screen",
      "route": "/documents/:id/print",
      "locationPath": "Compras > Documentos > Imprimir",
      "generalDescription": "Copia interna del documento de compra registrado para archivo o auditoría.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Imprimir",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Desde el listado pulse Nuevo o Editar.",
        "Complete la cabecera obligatoria.",
        "Agregue o ajuste líneas en la grilla de ítems.",
        "Revise totales y observaciones.",
        "Guarde; confirme el mensaje de éxito."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-documentos-edit"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-select-sede",
      "name": "Selección de sede de compra",
      "type": "screen",
      "route": "/compras/select-site",
      "locationPath": "Compras > Seleccionar sede",
      "generalDescription": "Pantalla de contexto cuando la empresa opera con varias sedes de compra. Debe elegir sede antes de crear requerimientos, OC, OS o documentos; la sede filtra numeración y reportes.",
      "prerequisites": [
        "Flag comprasPurchaseSitesEnabled activo.",
        "Usuario con acceso a más de una sede o sin sede por defecto."
      ],
      "interfaceElements": [
        {
          "name": "Lista de sedes",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Sedes configuradas en Gestión → Configuración → Sedes de compra.",
          "behavior": ""
        },
        {
          "name": "Continuar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Fija la sede en sesión y redirige al módulo.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Al ingresar a Compras sin sede, el sistema puede redirigir aquí.",
        "Seleccione la sede del día.",
        "Confirme y continúe al listado deseado."
      ],
      "practicalExample": {
        "context": "Comprador atiende Lima y Arequipa.",
        "data": {
          "Sede": "Lima"
        },
        "steps": [
          "Elija Lima",
          "Cree la OC"
        ]
      },
      "validations": [
        "Debe elegir una sede antes de operar documentos bajo ComprasPurchaseSiteGate."
      ],
      "expectedResult": [
        "Sede visible en barra superior; documentos nuevos quedan asociados."
      ],
      "commonErrors": [
        {
          "error": "Bucle de selección",
          "cause": "Sede sin permiso o desactivada.",
          "solution": "Administrador revisa sedes y usuario."
        }
      ],
      "relatedFunctions": [
        "compras-sede-historico",
        "gestion-config-sedes-compra"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => ctx.settings?.comprasPurchaseSitesEnabled
  }),

  functionDoc({
    
      "id": "compras-sede-historico",
      "name": "Asignar sede (histórico)",
      "type": "form",
      "route": "/compras/purchase-site-assignment",
      "locationPath": "Compras > Asignar sede (histórico)",
      "generalDescription": "Herramienta administrativa para asignar o corregir la sede de compra en documentos históricos creados antes de activar sedes o migraciones. No reemplaza la sede activa de sesión.",
      "prerequisites": [
        "comprasPurchaseSitesEnabled.",
        "Usuario administrador (no limitado)."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Rango de fechas, tipo de documento, proveedor.",
          "behavior": ""
        },
        {
          "name": "Documentos elegibles con sede actual y selector de sede destino.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Aplicar asignación",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Procesa lote según selección.",
          "behavior": "Puede tardar; no cierre la ventana."
        }
      ],
      "procedure": [
        "Compras → Asignar sede (histórico).",
        "Filtre el universo de documentos a corregir.",
        "Seleccione filas y sede destino.",
        "Ejecute y verifique en reporte de registro."
      ],
      "practicalExample": {
        "context": "Migración a sedes en marzo.",
        "data": {
          "Mes": "Enero–febrero 2026"
        },
        "steps": [
          "Filtrar",
          "Asignar sede Lima masivamente"
        ]
      },
      "validations": [
        "Solo documentos en estados permitidos aparecen en el lote."
      ],
      "expectedResult": [
        "Reportes por sede cuadran tras la asignación."
      ],
      "commonErrors": [
        {
          "error": "No veo el menú",
          "cause": "Usuario limitado o flag desactivado.",
          "solution": "Active sedes y use cuenta administrador."
        }
      ],
      "relatedFunctions": [
        "compras-select-sede",
        "compras-report-registro"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie."
      ],
      "roles": "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
    ,
    isVisible: (ctx) => ctx.settings?.comprasPurchaseSitesEnabled && !ctx.isLimitedUser
  }),

  functionDoc({
    
      "id": "compras-report-registro",
      "name": "Registro de documentos (compras)",
      "type": "report",
      "route": "/compras/reports/document-register",
      "locationPath": "Compras > Reportes > Registro de documentos",
      "generalDescription": "Listado filtrable de documentos de compra para auditoría y conciliación con proveedores. Muestra montos en PEN y/o USD según dual currency.",
      "prerequisites": [
        "Acceso a Compras y datos históricos de compras registrados."
      ],
      "interfaceElements": [
        {
          "name": "Rango de fechas",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Fechas",
          "behavior": ""
        },
        {
          "name": "Proveedor y tipo",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Select",
          "behavior": ""
        },
        {
          "name": "Detalle por documento con totales y estado.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        }
      ],
      "procedure": [
        "Compras → Reportes → seleccione la vista.",
        "Defina filtros obligatorios (fechas, etc.).",
        "Ejecute la consulta o espere la carga automática.",
        "Analice totales y use enlaces de trazabilidad si aparecen."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Períodos muy amplios pueden tardar en cargar; acote fechas."
      ],
      "expectedResult": [
        "Totales conciliables con contabilidad y registro SUNAT interno."
      ],
      "commonErrors": [
        {
          "error": "Montos en cero",
          "cause": "Sin documentos confirmados en el rango.",
          "solution": "Amplíe fechas o verifique estado de documentos."
        }
      ],
      "relatedFunctions": [
        "compras-documentos-list",
        "compras-report-precios-dashboard"
      ],
      "observations": [],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-report-precios-dashboard",
      "name": "Dashboard de precios (compras)",
      "type": "report",
      "route": "/compras/reports/price-tracking",
      "locationPath": "Compras > Reportes > Dashboard de precios",
      "generalDescription": "Vista general de variación de precios de compra: indicadores, últimas compras y accesos a alertas, proveedores, productos e historial.",
      "prerequisites": [
        "Acceso a Compras y datos históricos de compras registrados."
      ],
      "interfaceElements": [
        {
          "name": "KPIs y gráficos",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": true,
          "description": "Resumen de incrementos y productos críticos.",
          "behavior": ""
        },
        {
          "name": "Ir a alertas",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Navega a subreporte.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Compras → Reportes → seleccione la vista.",
        "Defina filtros obligatorios (fechas, etc.).",
        "Ejecute la consulta o espere la carga automática.",
        "Analice totales y use enlaces de trazabilidad si aparecen."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Períodos muy amplios pueden tardar en cargar; acote fechas."
      ],
      "expectedResult": [
        "Vista con datos coherentes con documentos de compra del período."
      ],
      "commonErrors": [
        {
          "error": "Montos en cero",
          "cause": "Sin documentos confirmados en el rango.",
          "solution": "Amplíe fechas o verifique estado de documentos."
        }
      ],
      "relatedFunctions": [
        "compras-report-precios-alertas",
        "compras-report-precios-productos"
      ],
      "observations": [],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-report-precios-alertas",
      "name": "Alertas de precio (compras)",
      "type": "report",
      "route": "/compras/reports/price-tracking/alerts",
      "locationPath": "Compras > Reportes > Alertas de precio",
      "generalDescription": "Productos cuyo último precio de compra superó umbral respecto al histórico o lista anterior. Prioriza negociación con proveedor.",
      "prerequisites": [
        "Acceso a Compras y datos históricos de compras registrados."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Rango de fechas, proveedor, producto u otros según el reporte.",
          "behavior": ""
        },
        {
          "name": "Resultados agregados o detalle según la vista.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Exportar / Imprimir",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Disponible si la pantalla lo ofrece.",
          "behavior": "Genera archivo o vista de impresión del filtro actual."
        }
      ],
      "procedure": [
        "Compras → Reportes → seleccione la vista.",
        "Defina filtros obligatorios (fechas, etc.).",
        "Ejecute la consulta o espere la carga automática.",
        "Analice totales y use enlaces de trazabilidad si aparecen."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Períodos muy amplios pueden tardar en cargar; acote fechas."
      ],
      "expectedResult": [
        "Vista con datos coherentes con documentos de compra del período."
      ],
      "commonErrors": [
        {
          "error": "Montos en cero",
          "cause": "Sin documentos confirmados en el rango.",
          "solution": "Amplíe fechas o verifique estado de documentos."
        }
      ],
      "relatedFunctions": [
        "compras-report-precios-dashboard",
        "compras-report-precios-historial"
      ],
      "observations": [],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-report-precios-proveedores",
      "name": "Proveedores — seguimiento de precios",
      "type": "report",
      "route": "/compras/reports/price-tracking/suppliers",
      "locationPath": "Compras > Reportes > Proveedores (compras)",
      "generalDescription": "Ranking y detalle de compras por proveedor con énfasis en evolución de precios y volumen.",
      "prerequisites": [
        "Acceso a Compras y datos históricos de compras registrados."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Rango de fechas, proveedor, producto u otros según el reporte.",
          "behavior": ""
        },
        {
          "name": "Resultados agregados o detalle según la vista.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Exportar / Imprimir",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Disponible si la pantalla lo ofrece.",
          "behavior": "Genera archivo o vista de impresión del filtro actual."
        }
      ],
      "procedure": [
        "Compras → Reportes → seleccione la vista.",
        "Defina filtros obligatorios (fechas, etc.).",
        "Ejecute la consulta o espere la carga automática.",
        "Analice totales y use enlaces de trazabilidad si aparecen."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Períodos muy amplios pueden tardar en cargar; acote fechas."
      ],
      "expectedResult": [
        "Vista con datos coherentes con documentos de compra del período."
      ],
      "commonErrors": [
        {
          "error": "Montos en cero",
          "cause": "Sin documentos confirmados en el rango.",
          "solution": "Amplíe fechas o verifique estado de documentos."
        }
      ],
      "relatedFunctions": [
        "compras-proveedores-list",
        "compras-report-precios-productos"
      ],
      "observations": [],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-report-precios-productos",
      "name": "Precios por producto (compras)",
      "type": "report",
      "route": "/compras/reports/price-tracking/products",
      "locationPath": "Compras > Reportes > Precios por producto",
      "generalDescription": "Listado de productos con último precio, promedio y variación; enlace al detalle por producto.",
      "prerequisites": [
        "Acceso a Compras y datos históricos de compras registrados."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Rango de fechas, proveedor, producto u otros según el reporte.",
          "behavior": ""
        },
        {
          "name": "Resultados agregados o detalle según la vista.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Exportar / Imprimir",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Disponible si la pantalla lo ofrece.",
          "behavior": "Genera archivo o vista de impresión del filtro actual."
        }
      ],
      "procedure": [
        "Compras → Reportes → seleccione la vista.",
        "Defina filtros obligatorios (fechas, etc.).",
        "Ejecute la consulta o espere la carga automática.",
        "Analice totales y use enlaces de trazabilidad si aparecen."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Períodos muy amplios pueden tardar en cargar; acote fechas."
      ],
      "expectedResult": [
        "Vista con datos coherentes con documentos de compra del período."
      ],
      "commonErrors": [
        {
          "error": "Montos en cero",
          "cause": "Sin documentos confirmados en el rango.",
          "solution": "Amplíe fechas o verifique estado de documentos."
        }
      ],
      "relatedFunctions": [
        "compras-report-precios-producto-detalle",
        "gestion-productos-list"
      ],
      "observations": [],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-report-precios-producto-detalle",
      "name": "Detalle de precios por producto",
      "type": "report",
      "route": "/compras/reports/price-tracking/products/:productId",
      "locationPath": "Compras > Reportes > Precios por producto > Detalle",
      "generalDescription": "Curva e historial de compras de un producto específico: proveedores, fechas y montos unitarios.",
      "prerequisites": [
        "Acceso a Compras y datos históricos de compras registrados."
      ],
      "interfaceElements": [
        {
          "name": "Gráfico de tendencia",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": true,
          "description": "Gráfico",
          "behavior": ""
        },
        {
          "name": "Compras línea a línea.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        }
      ],
      "procedure": [
        "Compras → Reportes → seleccione la vista.",
        "Defina filtros obligatorios (fechas, etc.).",
        "Ejecute la consulta o espere la carga automática.",
        "Analice totales y use enlaces de trazabilidad si aparecen."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Períodos muy amplios pueden tardar en cargar; acote fechas."
      ],
      "expectedResult": [
        "Vista con datos coherentes con documentos de compra del período."
      ],
      "commonErrors": [
        {
          "error": "Montos en cero",
          "cause": "Sin documentos confirmados en el rango.",
          "solution": "Amplíe fechas o verifique estado de documentos."
        }
      ],
      "relatedFunctions": [
        "compras-report-precios-productos",
        "compras-report-precios-historial"
      ],
      "observations": [],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-report-precios-historial",
      "name": "Historial de precios (compras)",
      "type": "report",
      "route": "/compras/reports/price-tracking/history",
      "locationPath": "Compras > Reportes > Historial de precios",
      "generalDescription": "Consulta cronológica de cambios de precio de compra filtrable por producto, proveedor y período.",
      "prerequisites": [
        "Acceso a Compras y datos históricos de compras registrados."
      ],
      "interfaceElements": [
        {
          "name": "Filtros",
          "controlType": "Campos / select",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Rango de fechas, proveedor, producto u otros según el reporte.",
          "behavior": ""
        },
        {
          "name": "Resultados agregados o detalle según la vista.",
          "controlType": "Tabla",
          "required": false,
          "editable": false,
          "automatic": true,
          "behavior": ""
        },
        {
          "name": "Exportar / Imprimir",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Disponible si la pantalla lo ofrece.",
          "behavior": "Genera archivo o vista de impresión del filtro actual."
        }
      ],
      "procedure": [
        "Compras → Reportes → seleccione la vista.",
        "Defina filtros obligatorios (fechas, etc.).",
        "Ejecute la consulta o espere la carga automática.",
        "Analice totales y use enlaces de trazabilidad si aparecen."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Períodos muy amplios pueden tardar en cargar; acote fechas."
      ],
      "expectedResult": [
        "Vista con datos coherentes con documentos de compra del período."
      ],
      "commonErrors": [
        {
          "error": "Montos en cero",
          "cause": "Sin documentos confirmados en el rango.",
          "solution": "Amplíe fechas o verifique estado de documentos."
        }
      ],
      "relatedFunctions": [
        "compras-report-precios-alertas",
        "compras-report-registro"
      ],
      "observations": [],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear.",
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-sede-contexto-barra",
      "name": "Cambiar sede de compra (barra superior)",
      "type": "screen",
      "route": "/purchase-orders",
      "locationPath": "Compras > Barra superior > Sede de compra",
      "generalDescription": "Selector de sede de compra activa en la barra superior cuando comprasPurchaseSitesEnabled está activo. Cambiar de sede altera el contexto de listados y documentos nuevos sin modificar registros ya guardados bajo otra sede.",
      "prerequisites": [
        "Sedes configuradas en Gestión.",
        "Usuario con acceso a más de una sede."
      ],
      "interfaceElements": [
        {
          "name": "Selector de sede",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Muestra la sede actual y permite cambiarla.",
          "behavior": ""
        },
        {
          "name": "Ir a selección completa",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Redirige a /compras/select-site si aplica.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Ubique el selector de sede junto al menú o título del módulo.",
        "Elija la sede con la que trabajará en esta sesión.",
        "Verifique que los listados muestran documentos de esa sede."
      ],
      "practicalExample": {
        "context": "El mismo comprador atiende sede Lima por la mañana y Callao por la tarde.",
        "data": {
          "Mañana": "Lima",
          "Tarde": "Callao"
        },
        "steps": [
          "Cambiar selector a Callao",
          "Crear documento",
          "Confirmar que la sede quedó en Callao"
        ]
      },
      "validations": [
        "Documentos históricos no cambian de sede al usar el selector; use Asignar sede (histórico) para correcciones masivas."
      ],
      "expectedResult": [
        "Listados y altas usan la sede seleccionada."
      ],
      "commonErrors": [
        {
          "error": "No veo el selector",
          "cause": "Flag de sedes desactivado.",
          "solution": "Active comprasPurchaseSitesEnabled."
        }
      ],
      "relatedFunctions": [
        "compras-select-sede",
        "gestion-config-sedes-compra"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Vista general de la pantalla con menú lateral y área de trabajo."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => ctx.settings?.comprasPurchaseSitesEnabled
  }),

  functionDoc({
    
      "id": "compras-continuos-registrar-periodo",
      "name": "Servicios continuos — registrar factura del período",
      "type": "form",
      "route": "/continuous-services/:id",
      "locationPath": "Compras > Servicios continuos > Detalle > Registrar documento",
      "generalDescription": "Flujo dentro del detalle del servicio continuo para generar o vincular el documento de compra del período (mensual, etc.) sin salir del contrato recurrente.",
      "prerequisites": [
        "Acceso de escritura en Compras.",
        "Maestros previos cargados (proveedor, productos, unidades) según el documento."
      ],
      "interfaceElements": [
        {
          "name": "Período a facturar",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Mes o rango del servicio.",
          "behavior": ""
        },
        {
          "name": "Monto del período",
          "controlType": "Campo",
          "required": true,
          "editable": true,
          "automatic": false,
          "description": "Puede heredar del contrato con ajustes.",
          "behavior": ""
        },
        {
          "name": "Crear documento de compra",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Abre formulario precargado con proveedor y líneas.",
          "behavior": ""
        },
        {
          "name": "Guardar",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Persiste cabecera e ítems según validaciones.",
          "behavior": "Muestra errores de validación en línea si faltan datos."
        },
        {
          "name": "Cancelar / Volver",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Regresa al listado sin guardar cambios pendientes.",
          "behavior": ""
        }
      ],
      "procedure": [
        "Abra el servicio continuo desde el listado.",
        "En detalle elija Registrar documento del período.",
        "Confirme período y monto.",
        "Complete el documento de compra y guarde."
      ],
      "practicalExample": {
        "context": "Operación rutinaria del área.",
        "data": {},
        "steps": [
          "Abrir pantalla",
          "Completar datos",
          "Guardar"
        ]
      },
      "validations": [
        "Campos marcados como obligatorios deben completarse antes de guardar."
      ],
      "expectedResult": [
        "Registro guardado con numeración o estado actualizado.",
        "Disponible en listados y reportes asociados."
      ],
      "commonErrors": [
        {
          "error": "No guarda por proveedor vacío",
          "cause": "Cabecera incompleta.",
          "solution": "Seleccione proveedor del catálogo o créelo en Proveedores."
        },
        {
          "error": "Línea sin producto",
          "cause": "Grilla con fila incompleta.",
          "solution": "Elimine la fila vacía o seleccione producto y cantidad."
        }
      ],
      "relatedFunctions": [
        "compras-continuos-detail",
        "compras-documentos-form"
      ],
      "observations": [
        "Administrador: puede crear, editar y anular según reglas del módulo; accede a configuración global."
      ],
      "screenshots": [
        "Formulario completo con cabecera, grilla de ítems y botones de acción al pie.",
        "Mensaje de confirmación o toast tras guardar correctamente."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    
  }),

  functionDoc({
    
      "id": "compras-sunatalias-limitado",
      "name": "Relación Productos SUNAT (desde Compras)",
      "type": "screen",
      "route": "/sunat-mappings",
      "locationPath": "Compras > Relación Productos SUNAT",
      "generalDescription": "Acceso directo al maestro de relación producto interno ↔ código SUNAT para usuarios limitados que tienen Compras pero no el menú Gestión completo. Misma pantalla que Gestión → Relación Productos SUNAT.",
      "prerequisites": [
        "Usuario limitado sin showGestion y con Compras visible."
      ],
      "interfaceElements": [
        {
          "name": "Buscador de producto",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "SKU o nombre.",
          "behavior": ""
        },
        {
          "name": "Código SUNAT",
          "controlType": "Campo",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "Asignación tributaria.",
          "behavior": ""
        },
        {
          "name": "Guardar fila",
          "controlType": "Botón",
          "required": false,
          "editable": true,
          "automatic": false,
          "description": "",
          "behavior": ""
        }
      ],
      "procedure": [
        "Compras → Relación Productos SUNAT.",
        "Busque producto.",
        "Asigne código y guarde."
      ],
      "practicalExample": {
        "context": "Comprador limitado corrige código SUNAT de un insumo.",
        "data": {},
        "steps": [
          "Buscar",
          "Editar código",
          "Guardar"
        ]
      },
      "validations": [
        "Producto debe existir en catálogo global."
      ],
      "expectedResult": [
        "Relación guardada para futuras facturas electrísticas de venta que usen ese producto."
      ],
      "commonErrors": [
        {
          "error": "No aparece en menú Compras",
          "cause": "Tiene también Gestión o es administrador.",
          "solution": "Use Gestión → Relación Productos SUNAT."
        }
      ],
      "relatedFunctions": [
        "gestion-sunat-mappings"
      ],
      "observations": [
        "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
      ],
      "screenshots": [
        "Listado con filtros superiores, tabla de resultados y botón Nuevo o Crear."
      ],
      "roles": "Usuario limitado: solo lectura en la mayoría de módulos; puede operar Compras y, si está asignado, guías de almacén o kardex según su perfil."
    ,
    isVisible: (ctx) => ctx.isLimitedUser && !ctx.limitedScope?.showGestion
  }),

  functionDoc({
    id: 'compras-grilla-productos-items',
    name: 'Grilla de productos e ítems — Compras',
    type: 'screen',
    route: '/purchase-orders/create',
    locationPath:
      'Compras > Requerimiento / Orden de compra → bloque «Productos» o «Ítems»',
    generalDescription:
      'La misma interfaz de líneas de producto que en otros módulos (captura rápida, Excel, filas con ProductSelector). La guía de columnas y comportamiento común está en Inicio y acceso → «Grilla de productos e ítems». En Compras destaca: requerimiento sin precios ni IGV en línea; orden de compra con precio, toggle «Precios incluyen IGV», unidad editable, vínculo a requerimientos y modal para jalar ítems pendientes; plantilla Excel compartida con la de ítems de OC.',
    prerequisites: [
      'Sede de compra seleccionada si la empresa opera con varias sedes.',
      'Productos y unidades en Gestión; proveedor obligatorio en orden de compra.',
    ],
    interfaceElements: [
      {
        name: 'Índice de fichas por pantalla',
        controlType: 'Documentación',
        required: false,
        editable: false,
        automatic: true,
        description:
          'Cada variante tiene su propia ficha con todos los inputs y selects en Inicio y acceso.',
        behavior:
          'Requerimiento → general-grilla-detalle-requerimiento-compras. OC → general-grilla-detalle-oc-compras. OS compras → general-grilla-detalle-os-compras. Controles sobre la tabla → general-grilla-detalle-controles-comunes.',
      },
    ],
    procedure: [
      'Consulte la guía general en Inicio y acceso si no conoce captura rápida o Excel.',
      'En requerimiento: cargue cantidades por área/proyecto y guarde.',
      'En OC: elija proveedor, ajuste «Precios incluyen IGV» según cotización del proveedor.',
      'Agregue líneas o importe desde requerimiento aprobado / Excel.',
      'Revise totales de OC y guarde; recepcione en guía de ingreso en Almacenes.',
    ],
    practicalExample: {
      context: 'OC desde requerimiento de mantenimiento.',
      data: { Requerimiento: 'REQ-2026-0088', Proveedor: 'Ferretería Norte SAC' },
      steps: [
        'Nueva OC → proveedor.',
        'Modal requerimientos → marque REQ-2026-0088 → importe líneas.',
        'Complete precios del proveedor y guarde OC.',
      ],
    },
    validations: [
      'Requerimiento: al menos un producto con cantidad > 0.',
      'OC: proveedor, al menos un ítem, precios coherentes con toggle de IGV.',
      'Cantidades recepcionadas en guía no deben superar pendiente de OC.',
    ],
    expectedResult: [
      'Requerimiento con avance; OC con totales y vínculo a REQ si importó.',
      'Guía de ingreso puede jalar líneas pendientes de la OC.',
    ],
    commonErrors: [
      {
        error: 'Total OC no coincide con factura del proveedor',
        cause: 'Criterio de precios con/sin IGV distinto al del proveedor.',
        solution: 'Ajuste el toggle y la tasa IGV de cabecera.',
      },
      {
        error: 'No importa requerimiento',
        cause: 'REQ sin saldo pendiente o sede distinta.',
        solution: 'Verifique estado del requerimiento y sede activa.',
      },
    ],
    relatedFunctions: [
      'general-grilla-productos-items',
      'general-grilla-detalle-requerimiento-compras',
      'general-grilla-detalle-oc-compras',
      'general-grilla-detalle-os-compras',
      'general-grilla-detalle-controles-comunes',
      'compras-oc-form',
      'compras-requerimientos-create',
      'almacenes-grilla-productos-items',
    ],
    observations: [
      'Abra las fichas «Grilla — fila …» en Inicio y acceso: listan cada columna con tipo de control y comportamiento.',
    ],
    screenshots: [SHOTS.formularioCompleto],
    roles: ROLES.limitado,
  }),
];
